import { create } from 'zustand';

interface ResponseData {
  qrHash: string;
  createDate: string;
}

interface QrState {
  mainQrData: Partial<ResponseData>;
  sideQrData: Partial<ResponseData>;
  qaData: Partial<ResponseData>; // For backward compatibility
  setQrData: (qrData: Partial<ResponseData>) => void;
  setMainQrData: (qrData: Partial<ResponseData>) => void;
  setSideQrData: (qrData: Partial<ResponseData>) => void;
}

// Zustand 스토어 생성
const qrStore = create<QrState>((set) => ({
  mainQrData: {
    qrHash: '',
    createDate: '',
  },
  sideQrData: {
    qrHash: '',
    createDate: '',
  },
  qaData: {
    qrHash: '',
    createDate: '',
  }, // For backward compatibility
  // For backward compatibility - sets both qaData and mainQrData
  setQrData: (qrData: Partial<ResponseData>) => set({ 
    qaData: qrData,
    mainQrData: qrData 
  }),
  setMainQrData: (qrData: Partial<ResponseData>) => set({ 
    mainQrData: qrData,
    qaData: qrData, // Update the legacy qaData as well
  }),
  setSideQrData: (qrData: Partial<ResponseData>) => set({ sideQrData: qrData }),
}));

export { qrStore };
